import { createAction, props } from '@ngrx/store';
import { Consent, Country } from '@shared/interfaces';

export const loadCountries = createAction(
  '[Datalists] Load Countries',
  props<{ lang: string }>()
);

export const addCountries = createAction(
  '[Metadata] Add Countries',
  props<{ countries: Country[] }>()
);

export const loadConsents = createAction(
  '[Datalists] Load Consents',
  props<{ lang: string }>()
);

export const addConsents = createAction(
  '[Metadata] Add Consents',
  props<{ consents: {[key in string]: Consent} }>()
);

export const loadFailure = createAction(
  '[Metadata] Failure',
  props<{ error: string }>()
);
